import * as React from 'react';
import { SVGProps } from 'react';
const SvgShrinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.987 10.81H14.11c-.896 0-1.415-.527-1.415-1.423v-4.87c0-.456.343-.817.809-.817s.8.352.8.818v.738l-.185 3.067 2.32-2.434 2.699-2.725a.764.764 0 0 1 .562-.237c.501 0 .87.334.87.826a.858.858 0 0 1-.246.606l-2.707 2.707-2.434 2.312 3.067-.176h.738c.466 0 .827.325.827.8 0 .466-.352.808-.827.808Zm-8.428 8.921c-.466 0-.8-.342-.8-.817v-.835l.184-3.059-2.32 2.435-2.76 2.777a.75.75 0 0 1-.562.238c-.492 0-.862-.334-.862-.826a.85.85 0 0 1 .238-.607l2.768-2.768 2.444-2.312-3.076.176h-.835c-.466 0-.827-.325-.827-.791 0-.475.352-.809.827-.809h4.974c.897 0 1.415.519 1.415 1.415v4.966c0 .466-.334.817-.808.817Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgShrinkIcon;
